"use client";

import { useEffect } from "react";
import Script from "next/script";
import { useTrackingConsent } from "@/lib/consent/use-tracking-consent";
import { getPostHogInitScript, syncPostHogConsent } from "@/lib/analytics/posthog-consent";

/** Load only after the shared regional/privacy decision permits tracking. */
export default function PostHogTracker() {
  const allowed = useTrackingConsent();
  useEffect(() => {
    // Wrapped: a listener would receive the Event as syncPostHogConsent's
    // `instance` argument.
    const onUpdate = () => syncPostHogConsent();
    window.addEventListener("consent_update", onUpdate);
    onUpdate();
    return () => window.removeEventListener("consent_update", onUpdate);
  }, []);

  return allowed ? (
    <Script
      id="posthog-init"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{ __html: getPostHogInitScript() }}
    />
  ) : null;
}
